export const REPORT_TOASTS = {
  REPORT_DELETED: 'Report successfully deleted',
  REPORT_UPDATED: 'Report successfully updated',
  REPORT_CREATED: 'Report successfully created',
};
